/* Bagel Boys · theme.js
   Minimal vanilla JS:
   - Mobile nav drawer toggle
   - Cart drawer (open/close, AJAX add, update qty, remove)
   - Live stock count refresh (optional)
*/

(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.from((root || document).querySelectorAll(sel)); };

  // =============================================================
  // Mobile nav drawer
  // =============================================================
  function initMobileNav() {
    var toggle = $('.bb-header__menu-toggle');
    var drawer = $('.bb-mnav');
    var overlay = $('.bb-overlay');
    var close = $('.bb-mnav__close');

    if (!toggle || !drawer) return;

    var open = function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var closeFn = function () { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; };

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeFn);
    if (overlay) overlay.addEventListener('click', closeFn);
  }

  // =============================================================
  // Cart drawer
  // =============================================================
  function initCartDrawer() {
    var drawer = $('.bb-cart');
    if (!drawer) return;

    var overlay = $('.bb-cart-overlay');
    var closeBtn = $('.bb-cart__close');

    var openDrawer = function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var closeDrawer = function () { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; };

    // Any [data-cart-toggle] or [href="/cart"] opens the drawer when drawer is enabled
    $$('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // AJAX add to cart from any form with data-cart-add or from product-card buttons
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(openDrawer)
        .catch(function (err) { console.warn('[bagel-boys] add-to-cart failed', err); });
    });

    // Quick-add + button on product cards (outside of a form)
    document.addEventListener('click', function (e) {
      var quick = e.target.closest('[data-quick-add]');
      if (!quick) return;
      e.preventDefault(); e.stopPropagation();
      var vid = quick.getAttribute('data-variant-id');
      if (!vid) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(openDrawer)
        .catch(function (err) { console.warn('[bagel-boys] quick-add failed', err); });
    });

    // Qty +/- and remove from within drawer
    drawer.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-qty-change]');
      var rmBtn = e.target.closest('[data-line-remove]');
      if (incBtn) {
        var line = parseInt(incBtn.getAttribute('data-line'), 10);
        var delta = parseInt(incBtn.getAttribute('data-qty-change'), 10);
        var qtyEl = drawer.querySelector('[data-line-qty="' + line + '"]');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        var next = Math.max(0, current + delta);
        changeLine(line, next);
      } else if (rmBtn) {
        changeLine(parseInt(rmBtn.getAttribute('data-line'), 10), 0);
      }
    });

    // Expose open/close on window for inline triggers if ever needed
    window.BagelBoysCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  function refreshCart() {
    return fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // Replace drawer inner content
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.bb-cart');
        var existing = document.querySelector('.bb-cart');
        if (fresh && existing) existing.innerHTML = fresh.innerHTML;

        // Update header cart count from any element with the right attr
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  // =============================================================
  // Boot
  // =============================================================
  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCartDrawer();
  });
})();
